import { TransferPricingDocumentationRequestHelper } from './transfer-pricing-documentation-request-helper';
import type {
  ITransferPricingDocumentationRecordResponse,
  IUpdateTransferPricingDocumentationDatesParams,
  TTransferPricingDocumentationMutationResult,
} from './types';

const FALLBACK_ERROR_MESSAGE = 'Could not save the date. Please try again.';

export const updateTransferPricingDocumentationDates = (
  documentationId: string,
  params: IUpdateTransferPricingDocumentationDatesParams,
  token?: string
): Promise<
  TTransferPricingDocumentationMutationResult<ITransferPricingDocumentationRecordResponse>
> =>
  TransferPricingDocumentationRequestHelper.send({
    path: `${TransferPricingDocumentationRequestHelper.recordPath(documentationId)}/dates`,
    method: 'PATCH',
    body: { ...params },
    isExpectedBody: TransferPricingDocumentationRequestHelper.hasDocumentation,
    fallbackErrorMessage: FALLBACK_ERROR_MESSAGE,
    token,
  });
